/**
 * Shown where activity-event data would be when the controller says the
 * activity store is absent. Deliberately not ErrorState: on a deployment
 * without DAM this is the expected state, there is nothing to retry, and a red
 * "failed to load" banner would send someone looking for an outage.
 */
import { Database } from 'lucide-react';

import type { ActivityStoreStatus } from '@/lib/api';

const REASON_TEXT: Record<NonNullable<ActivityStoreStatus['reason']>, string> = {
  not_configured: 'No activity store is configured for this deployment.',
  unreachable: 'The activity store cannot be reached right now.',
};

export function ActivityStoreNotice({
  status,
  what = 'Activity monitoring data',
}: {
  status?: ActivityStoreStatus | undefined;
  what?: string;
}) {
  const reason = status?.reason ? REASON_TEXT[status.reason] : 'The activity store is not available.';
  return (
    <div
      role="status"
      className="glass-lite rounded-md px-4 py-3 mb-4 flex items-start gap-3 text-xs text-muted-foreground"
    >
      <Database className="h-4 w-4 mt-0.5 shrink-0" />
      <div>
        <span className="font-medium text-foreground">Not available.</span> {what} is not available. {reason}
      </div>
    </div>
  );
}
